import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateBatch = ({ id, input }) => {
  const mutation = require("../api/mutation/updateBatch.gql");
  const variables = { id, input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.updateBatch };
    } else if (error) return { error: JSON.stringify(error) };
  });
};

export const deleteBatch = id => {
  const mutation = require("../api/mutation/deleteBatch.gql");
  const variables = { id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.deleteBatch };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
